export const ENGAGEMENT_RATINGS = [
  {
    value: 'green',
    label: 'Frequent',
    tooltip: 'Engaged within the last 2 weeks',
    dotClass: 'bg-green-500',
    badgeClass: 'bg-green-100 text-green-800',
  },
  {
    value: 'amber',
    label: 'Occasional',
    tooltip: 'Last engaged 2-6 weeks ago',
    dotClass: 'bg-yellow-500',
    badgeClass: 'bg-yellow-100 text-yellow-500',
  },
  {
    value: 'red',
    label: 'Quiet',
    tooltip: 'No engagement for 6+ weeks',
    dotClass: 'bg-red-500',
    badgeClass: 'bg-red-100 text-red-800',
  },
  {
    value: 'none',
    label: 'No Activity',
    tooltip: 'Not yet engaged',
    dotClass: 'bg-gray-400',
    badgeClass: 'bg-gray-100 text-gray-600',
  },
];

const findRating = (value) => ENGAGEMENT_RATINGS.find((r) => r.value === value) ?? ENGAGEMENT_RATINGS[3];

export const engagementDotClass = (rating) => findRating(rating).dotClass;
export const engagementTooltip = (rating) => findRating(rating).tooltip;
export const engagementClass = (rating) => findRating(rating).badgeClass;
export const engagementLabel = (rating) => findRating(rating).label;
